var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-mark",style:(_vm.imgClass)})
}
var staticRenderFns = []

export { render, staticRenderFns }